import { autoCapitalize } from '@/utils/autoCapitalize'
import {
  ForwardingDataItem,
  ForwardingDataItemRaw,
  ForwardingListParams,
  ForwardingListParamsRaw,
} from './ForwardingListMapper.types'

class ForwardingListMapper {
  toDomain(response: ForwardingDataItemRaw[]): ForwardingDataItem[] {
    return response.map(item => ({
      cid: item.codigoCid,
      issueDate: item.dataEmissao,
      fileExtension: item.extensao,
      id: item.id?.toString(),
      forwardingId: item.idEncaminhamento,
      name: item.nome,
      professional: item.profissional
        ? {
            name: autoCapitalize(item.profissional.nome),
            councilNumber: item.profissional.numeroConselho,
            state: item.profissional.uf,
          }
        : undefined,
      url: item.url,
    }))
  }

  toPersistance(params: ForwardingListParams): ForwardingListParamsRaw {
    return {
      idEspecialidade: params.specialtyId,
      idPaciente: params.patientId,
    }
  }
}

export default new ForwardingListMapper()
